import React from 'react'

export default function ParityBadge({ parity }) {
  if (!parity) {
    return (
      <span className="tag is-light lox-no-border" data-testid="parity-badge">
        Checking underwriting…
      </span>
    )
  }
  if (parity.status === 'match') {
    return (
      <span
        className="tag is-success is-light lox-no-border"
        data-testid="parity-badge"
      >
        ✓ Matches underwriting
      </span>
    )
  }
  if (parity.status === 'unavailable') {
    return (
      <span className="tag is-light lox-no-border" data-testid="parity-badge">
        DS unavailable
      </span>
    )
  }

  const differences = [
    [
      'Only here',
      [
        ...(parity.numeric_only_in_lox ?? []),
        ...(parity.categorical_only_in_lox ?? []),
      ],
    ],
    [
      'Only in underwriting',
      [
        ...(parity.numeric_only_in_ds ?? []),
        ...(parity.categorical_only_in_ds ?? []),
      ],
    ],
  ].filter(([, ids]) => ids.length > 0)

  return (
    <span
      className="tag is-warning is-light lox-no-border has-tooltip-multiline has-tooltip-left"
      data-tooltip="Underwriting caches blocks for up to an hour, so a recent SQL change can differ until its cache clears."
      data-testid="parity-badge"
    >
      ≠ Differs:{' '}
      {differences
        .map(
          ([label, ids]) => `${label} ${ids.map((id) => `#${id}`).join(', ')}`
        )
        .join('; ')}
    </span>
  )
}
